import { useLocation } from 'react-router-dom';

export const useIsViewingOlderVersion = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const version = query.get('version');

  return version;
};
